import { CommonModule, Location } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FamilyService } from '../../../../../core/services/family.service';
import { FileService } from '../../../../../core/services/file.service';
import { FileService  as myFileService} from '../../../../../core/utils/file-service';
import { InscriptionFileService } from '../../../../../core/services/inscription-file.service';
import { InscriptionService } from '../../../../../core/services/inscription.service';
import { OldSchoolService } from '../../../../../core/services/old-school.service';
import { ParentService } from '../../../../../core/services/parent.service';
import { StudentAyClassroomService } from '../../../../../core/services/student-ay-classroom.service';
import { StudentService } from '../../../../../core/services/student.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-inscription-renew-details',
    templateUrl: './inscription-renew-details.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule],
    styleUrls: ['./inscription-renew-details.component.css']
})
export class InscriptionRenewDetailsComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  loading=false
  data:any
  user:any
  role:any
  insCode:any
  pdfViewLoader=false
  selected_data:any
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  is_active:any
  classrooms:any[]=[];
  requiredFiles:any[]=[];
  settedFiles:any[]=[];
  fileInput:any
  imageSrc!: string | SafeResourceUrl | undefined ;

  constructor(
    private location:Location,
    private classroomService:ClassroomService,
    private sacService:StudentAyClassroomService,
    private spinnerService:NgxSpinnerService,
    private familyService:FamilyService,
    private oldSchoolService:OldSchoolService,
    private studentService:StudentService,
    private insService:InscriptionService,
    private fileService:FileService,
    private inscriptionFileService:InscriptionFileService,
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private parentService:ParentService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
   }
  ngOnInit(): void {
   this.insCode=this.activatedRoute.snapshot.paramMap.get('code');
   this.user=this.lsService.get(GlobalName.userName)
   this.role=this.user.roles[0].name
   if (this.insCode== undefined) {
    this.router.navigate(['inscription-index'])

   } else {
    this.getClassrooms()
    this.getData()
   }
  }

  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des réinscriptions",err)
    })
  }

  getData(){
    this.spinnerService.show()
    this.insService.get(this.insCode,0).subscribe((res:any)=>{
      this.spinnerService.hide()

        this.data=res.data
        this.is_active=res.data?.student?.current_ay_classroom?.is_active
        this.selected_data=res.data?.student?.current_ay_classroom
        },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des réinscriptions",err)

    })
  }
  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des réinscriptions",err)

    })
  }

  store(value:any){

      this.settedFiles=this.requiredFiles.filter((res:any)=> res.isSetted==true);
      value['student_id']=this.data.id
      value['documents']=this.settedFiles
      this.loading=true
    this.insService.store(value).subscribe((res:any)=>{
      if (!res.data.success) {
        this.toastrService.info(res.message,'Réinscription')
        let confirmed=AppSweetAlert.confirmBox('info','Réinscription','voir l\'enregistrement?');
        confirmed.then((result:any)=>{
           if (result.isConfirmed) {
            this.router.navigate(['/admin/inscription-details/'+res.data])
            }
          })
      } else {
        this.router.navigate(['/admin/inscription-details/'+res.data])
        this.loading=false
      }
   
        },
    (err:any)=>{
      this.loading=false
      AppErrorShow.showError("Gestion des réinscriptions",err)

    })
  }
  
  loadDocuments(event:any){
    if (this.data?.current_ay_classroom?.classroom?.id == event.target.value) {
      AppSweetAlert.simpleAlert('warning','Réinscription','Vous êtes entrain de réinscire cet apprenant dans son ancienne classe ?',);
    }
    this.requiredFiles=[]
    this.inscriptionFileService.get(event.target.value).subscribe((res:any)=>{
      res.data.forEach((element:any) => this.requiredFiles.push({
        name:element.document?.name,
        fileArrayBuffer:"",
        file:"",
        file_id:element.document?.id,
        isRequired:element.is_active,
        description:"",
        isSetted:false,
        hasFilename:false
      }) );

    },
    (err:any)=>{
AppErrorShow.showError("Gestion des réinscriptions",err)
    })
  }
  async upload(event:any, index:any){
    if(event.target.files.length>0){
     this.fileInput=event.target.files[0]
      let current =this.requiredFiles[index];
         current.fileArrayBuffer=await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(this.fileInput)) 
         current.file=this.fileInput
         current.isSetted=true
         current.hasFilename=false
        this.requiredFiles.slice(index,current)
        console.log(this.requiredFiles)
    }
  } 

  removeFile(i:any){
    //this.fileInputs.splice(i,1)
    AppSweetAlert.confirmBox("error","Document joint","Voulez vous retier cette pièce ?").then((result:any)=>{
      if (result.isConfirmed) {
        this.requiredFiles[i].file="",
        this.requiredFiles[i].isSetted=false
      }
    })
   
  }
  

  validate(){
    this.loading=true
    this.insService.setState(this.insCode, 1).subscribe((res:any)=>{
      this.getData()
      this.loading=true

      },
  (err:any)=>{
    this.loading=true
    AppErrorShow.showError("Gestion des réinscriptions",err)

  })
  }

  open(content:any,el:any){
    this.selected_data=el
    this.modalService.open(content)
  }
  deleteFamily(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.familyService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getData()
      },
    (err:any)=>{
      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
})
  }
  editFamily(form:any){
    this.loading=true

    this.familyService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
  deleteSchool(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.oldSchoolService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getData()
      },
    (err:any)=>{
      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos Famille",err.error.message)
    })
  }
})
  }
  editSchool(form:any){
    this.loading=true

    this.oldSchoolService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }
  editStudent(form:any){
    this.loading=true

    this.studentService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }
  editParent(form:any){
    this.loading=true

    this.parentService.update(this.selected_data.id,form.value).subscribe((res:any)=>{
      this.loading=false
      this.modalService.dismissAll()
      form.resetForm()
      this.toastrService.success(res.message)
      this.getData()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppSweetAlert.simpleAlert("error","Infos établissement",err.error.message)
    })
  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.sacService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.location.back()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des réinscriptions",err)

      })
  }
}
